module.exports = __webpack_public_path__ + "static/media/powered_by_google_on_white.f241a554.png";